<div class="container-fluid glb-popup" style="min-width: 600px">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <div>
    <p>
      Select File to Upload:<input type="file" (change)="onFileChange($event)" />
    </p>
    <div id="output"></div>
    <div style="float:right"><a href="{{sampleFileLink}}" target="_blank">Sample File</a> </div>
    <br>
      <!--<div *ngIf="willDownload">
      <a id="download"> Download JSON File </a>
    </div>-->
  </div>

  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <app-tag-join-select
            [tagSource]="tagSourceForImport"  tagType="4" [tagSourceId]="0" [viewOnly]="true" (tagsSelectedEvent)="updateTagSelected($event)">
          </app-tag-join-select>
        </div>


      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>

            </div>
          </div>
        </div>
      </div>
    </div>
